// Link — the text-link primitive, pure.
//
// Rebuilt from foundations v1 against the design vision (.claude/research/design/06).
// A link is text that navigates; its whole job is to read as prose while
// still being unmistakably actionable. Two purposeful tones:
//
//   - neutral (default) — the link shares the body ink colour (--color-fg),
//     so a PERSISTENT underline is the only channel that says "this is a
//     link". That is deliberate: colour alone may not carry the link
//     affordance (SC 1.4.1), and a neutral link has no colour difference at
//     all, so the underline must be present at rest, not revealed on hover.
//   - accent — the one accent use: a link that is genuinely THE primary
//     navigational action in its view (the accent means "primary/agent",
//     §1). Same persistent underline; only the ink shifts to --color-accent.
//
// Pure/props-driven: `tone` picks the look; every other anchor attribute
// (href, onClick, target, rel, aria-*, download…) passes straight through.
// External links are supported by passing the standard attrs — `target` is
// NEVER forced, so the caller stays in control of navigation semantics.
// The link carries no intrinsic text of its own: the label is children, so
// user-facing strings are localised by the caller, not here.

import type { AnchorHTMLAttributes } from "react";
import "./Link.css";

export type LinkTone = "neutral" | "accent";

export type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
    readonly tone?: LinkTone;
};

export const Link = ({ tone = "neutral", className, ...rest }: LinkProps) => (
    <a
        className={`bilda-link bilda-link--${tone}${
            className ? ` ${className}` : ""
        }`}
        {...rest}
    />
);
